import styled from "styled-components";
import { InfoContainer } from "../../../../components/info-block/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap:20px;
  min-width: 0;
`
export const InputWrapper = styled.div`
  display: flex;
  gap:10px;
  align-items: center;
  position: relative;
  min-width: 0;

  > div:first-child {
    flex: 1;
    min-width: 0;
  }
`

export const ReportingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap:10px;
`

export const ReportingItems = styled.div`
  display: flex;
  gap:10px;
  flex-wrap: wrap;
  width:100%;
`

export const ReporingItem = styled(InfoContainer)`
  display: flex;
  flex-direction:column;
  gap:10px;
  width:535px;
  flex: none;
  flex-basis:0;
  flex-grow: 1;
  min-width: 0;
  overflow-wrap: anywhere;

  @media screen and (max-width:768px) {
    width: 100%;
    min-width: 0;
    flex-basis: auto;
  }

`
export const InfoBlockItem = styled.div`
  display: flex;
  flex-direction: column;
  width:535px;
  height:100%;
  border-radius: 8px;
  padding: 20px;
  gap:24px;
  background-color: ${({theme}) => theme.grey[100]};
  position: relative;
  box-sizing: border-box;
  flex: none;
  flex-basis:0;
  overflow: hidden;
  flex-grow: 1;

  @media screen and (max-width:768px) {
    width: 100%;
    min-width: 0;
    flex-basis: auto;
  }
`
export const ImgBig = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0px;

`
export const CopyContainer = styled.div`
  position:absolute;
  
  top:-10px;
  left:240px;
  /* right: 0px; */
  white-space: nowrap;
  /* width: 100px; */
  border-radius: 4px;
  padding: 2px 4px;
  background: ${({theme}) => theme.isDark ? '#474B53' : theme.palette[400]};

  @media screen and (max-width:600px) {
    right: 50px;
    left: auto;
    max-width: calc(100% - 60px);
    white-space: normal;
    overflow-wrap: anywhere;
  }

`

export const BalanceDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  min-width: 0;
  max-width: 100%;
  margin-top: 4px;
  overflow-wrap: anywhere;
`

export const MapWrapper = styled.div`
  width: 100%;
  min-width: 0;

  @media screen and (max-width:600px) {
    .worldmap__figure-container {
      display: flex;
      justify-content: center;
      width: 100%;
      max-width: 100%;
      margin: 0;
    }

    svg {
      display: block;
      width: auto;
      max-width: 100%;
      height: auto;
    }
  }
`
